// Настройки для интервалов через которые происходит обновление данных
export const MONITORING_EVENTS_DETAILS_UPDATE_INTERVALS = {
  EVENT_DETAILS: 60000, // Детализация событий, каждые 60 секунд
  LAST_INFO: 10000, // Обновлённая информация, каждые 10 секунд
  GET_SENSOR_EVENTS: 10000, // События с датчиков, каждые 10 секунд
  TRACK: 5000, // Информация о трэке, каждые 5 секунд
  TRACK_FOR_GRAPH: 60000 // Информация о трэке для диаграмм, каждые 60 секунд
};
